



























































import {
    BBadge,
    BButton,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormSelect,
    BInputGroup,
    BListGroup,
    BListGroupItem,
    BPopover,
    BSpinner,
} from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { computed, defineComponent, ref } from "@vue/composition-api";
import { styleByColor } from "@/utils/color";
import useContactLabels from "@/composables/v2.1/useContactLabels";
import ContactLabelInterface from "@/interfaces/contactLabel.interface";

export default defineComponent({
    components: {
        BBadge,
        BPopover,
        BListGroup,
        BListGroupItem,
        BFormGroup,
        BFormInput,
        BFormRadioGroup,
        BFormSelect,
        BInputGroup,
        BButton,
        ValidationProvider,
        BSpinner,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    setup(props, { emit }) {
        const { contactLabels, fetchContactLabels, loading: isLabelsLoading } = useContactLabels();

        if (!contactLabels.value?.length) {
            fetchContactLabels();
        }

        const searchText = ref("");

        const selectedLabels = computed<ContactLabelInterface[]>({
            get() {
                const labelIds = props.value.split(",");

                return (
                    labelIds
                        .map((labelId) => contactLabels.value.find((label) => label.id === Number(labelId)))
                        // Typescript does not understand that this means it is always defined, so we need to manually cast it
                        .filter((label) => Boolean(label)) as ContactLabelInterface[]
                );
            },
            set(labelsArray) {
                emit("input", labelsArray.map((label) => label.id).join(","));
            },
        });

        const selectableLabels = computed(() =>
            contactLabels.value.filter(
                (contactLabel) =>
                    contactLabel.name?.includes(searchText.value) &&
                    !selectedLabels.value.find((selectedLabel) => selectedLabel.id === contactLabel.id)
            )
        );

        const addLabel = (label: ContactLabelInterface) => {
            selectedLabels.value = [...selectedLabels.value, label];
        };

        const removeLabel = (labelId?: number) => {
            selectedLabels.value = selectedLabels.value.filter((label) => label.id !== labelId);
        };

        return {
            isLabelsLoading,
            selectedLabels,
            contactLabels,
            searchText,
            selectableLabels,
            styleByColor,

            addLabel,
            removeLabel,
        };
    },
});
